var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menubar-profile"},[_c('ProfileMenu',{staticClass:"menubar-profile-user"}),_c('NotificationMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }